import { Link } from "react-router-dom";
import { Phone, Mail, Globe } from "lucide-react";
import { CONTACT, NAV_LINKS } from "@/data/content";
import { CITIES } from "@/data/cities";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#163d78] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img src={CONTACT.logo} alt="Elite Facility Solutions" className="h-14 w-auto bg-white rounded-sm p-1.5" />
          <p className="mt-5 text-sm text-blue-100/80 leading-relaxed max-w-sm">
            Elite Facility Solutions delivers reliable, high-quality commercial cleaning, janitorial services and facility maintenance across Northeast Florida.
          </p>
          <div className="mt-6 space-y-2 text-sm">
            <a href={CONTACT.phoneHref} className="flex items-center gap-2 text-blue-100 hover:text-white transition-colors"><Phone size={16} /> {CONTACT.phone}</a>
            <a href={CONTACT.emailHref} className="flex items-center gap-2 text-blue-100 hover:text-white transition-colors"><Mail size={16} /> {CONTACT.email}</a>
            <p className="flex items-center gap-2 text-blue-100"><Globe size={16} /> {CONTACT.domain}</p>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-bold uppercase tracking-wide text-[#ff6b70] mb-4">Quick Links</h4>
          <ul className="space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.href}><a href={l.href} className="text-sm text-blue-100/80 hover:text-white transition-colors">{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold uppercase tracking-wide text-[#ff6b70] mb-4">Service Areas</h4>
          <ul className="space-y-2.5">
            {CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/commercial-cleaning/${c.slug}`} className="text-sm text-blue-100/80 hover:text-white transition-colors">
                  Cleaning in {c.name}, FL
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-blue-200/70">© {new Date().getFullYear()} Elite Facility Solutions. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/careers" className="text-xs text-blue-200/70 hover:text-white transition-colors">Careers</Link>
            <Link to="/portal" data-testid="footer-portal-link" className="text-xs text-blue-200/70 hover:text-white transition-colors">Employee Portal</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
